<template>
  <transition name="fade" appear>
    <div class="flex w-full flex-col px-4">
      <categories :categories="items"></categories>
      <menu-items :items="listOfConsumables" :description="categoryDescription"></menu-items>
    </div>
  </transition>
</template>

<script>
import Categories from "./Categories.vue";
import MenuItems from "./MenuItems.vue";
import { mapGetters } from "vuex";

export default {
  data: () => {
    return {
      lang: window.appLocale,
    };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  components: {
    Categories,
    MenuItems,
  },
  computed: {
    ...mapGetters({
      categorySelected: "getCategorySelected",
    }),
    listOfConsumables() {
      return this.categorySelected.consumables;
    },
    categoryDescription(){
      return this.categorySelected.dishes_description && this.categorySelected.dishes_description[this.lang] || this.categorySelected.wines_description && this.categorySelected.wines_description[this.lang];
    },
    categories() {},
  },
};
</script>

<style>
</style>
